//MARK: Done
export const SITE = {
  SITE: {
    PAGE: "site/page",
    LIST: {
      INDEX: "site/list",
      ACCOUNT: "site/list/account",
    },

    CREATE: "site/create",
    UPDATE: "site/update",
    DELETE: "site/delete",
    GET: "site/get",
  },
};
